import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocketBookingsService {

  constructor(private socket: Socket) { }
  createBooking(booking : any) {
    return new Observable(observer => {
       this.socket.emit('createBooking', booking);
       observer.next(this.socket.ioSocket.id);
       console.log(this.socket)
    });
  }
  joinRoom(joinRoomData) {
 
      let token = JSON.parse(localStorage.getItem('auth.token'))?.val

      if(!token){
        return;
      }
    this.socket.ioSocket.io.opts.query = { token:token };
 
    // this.socket.ioSocket.io.opts.extraHeaders = {
    //   Authorization: `Bearer ${token}`
    // };
  
    console.log(' this.socket.ioSocket====', this.socket, joinRoomData)
    if (!this.socket.ioSocket.connected) {
      this.socket.connect();
    }
    // this.socket.connect();
    this.socket.emit('joinRoom', joinRoomData);
    console.log(joinRoomData)
    // this.socket.disconnect();
    this.socket.connect();
  }
  getRoomUsers(){
    return new Observable(observer => {
      this.socket.on('roomUsers', (data) => {
        observer.next(data);
        console.log(data)
      });
    });
  }
  endBooking(booking : any) {
    this.socket.emit('endBooking', booking);
  }
  cancelThisBooking(booking : any) {
    console.log('cancel booking ====payload ==', booking)
    this.socket.emit('cancelBooking', booking);
  }
  getCancelledBookings() {
    
    return new Observable(observer => {
      this.socket.on('bookingCancelled', (data) => {
        observer.next(data);
      });
      
    });
  }
  approveBooking(booking : any) {
    console.log('APPROVE booking ====payload ==', booking)
    this.socket.emit('approveBooking', booking);
  }
  getApprovedBookings() {
    
    return new Observable(observer => {
      this.socket.on('bookingApproved', (data) => {
        console.log('data == booking approved ===',data )
        observer.next(data);
      });
      
    });
  }
  getBookingApprovalCount(userDetails) {
    this.socket.emit('bookingApprovalCount',userDetails);
  }
  getBookingApprovalNotification(){
    return new Observable(observer => {
      this.socket.on('getBookingApprovalCount', (data) => {
        observer.next(data);
        console.log(data)
      });
    });
  }
  onSocketError(){
    return new Observable(observer => {
      this.socket.on('connect_error', (error) => {
        console.log('error======',error)
        observer.next(error);
        
      });
    });
  }
  
  getBookings() {
    return new Observable(observer => {
      this.socket.on('bookingCreated', (data) => {
        observer.next(data);
        console.log('bookingCreated=======',data)
      });
      this.socket.on('bookingEnded', (data) => {
        observer.next(data);
        console.log('bookingEnded=====',data)
      });
      // return () => {
      //   this.socket.disconnect();
      // }
    });
    // return this.socket.on('bookingCreated',data => console.log(data) );
  }

  getEndedBookings() {
    return new Observable(observer => {
      this.socket.on('bookingEnded', (data) => {
        observer.next(data);
        console.log('bookingEnded=====',data)
      });
      
    });
  }

  disconnectSocket(){
     this.socket.disconnect();
  }

 

  // getAllVisits(visits:any){
  //   return new Observable(observer => {
  //     this.socket.emit('getVisits', visits);
  //     observer.next(this.socket);
  //     console.log('visitvisit',visits);
  //     console.log('this.socket',this.socket);
  //     console.log('this.socket.ioSocket.id',this.socket.ioSocket.ids);
  //  });
  // }

  // getAllVisitsFromBackend(){
  //   return new Observable(observer => {
  //     this.socket.on('visitsData', (data) => {
  //       observer.next(data);
  //       console.log('visitsData',data)
  //     });
  //   });
  // }
  getVisitWithFilters(payload) {
    this.socket.emit('getVisits', payload);
    console.log('payload',payload)

  }
  visitsResponse(){
    return new Observable(observer => {
      this.socket.on('visitsData', (data) => {
        observer.next(data);
        console.log('visitsData',data)

      });
    });
  }

  visitStatusChanged(){
    return new Observable(observer => {
      this.socket.on('visitStatusChanged', (data) => {
        observer.next(data);
        console.log('visitData',data)
      });
    });
  }

  visitStatusChange(visit : any) {
    // this.socket.emit('visitStatusChange', visit);
    return new Observable(observer => {
      this.socket.emit('visitStatusChange', visit);
      observer.next(this.socket.ioSocket.id);
   });
  }

  visitCreated(){
    return new Observable(observer => {
      this.socket.on('visitCreated', (data) => {
        observer.next(data);
        console.log('visitCreated',data)
      });
    });
  }

  createVisit(createVisit){
    this.socket.emit('createVisit', createVisit);
    console.log('createVisit',createVisit);
  //   return new Observable(observer => {
  //     this.socket.emit('createVisit', createVisit);
  //     alert('createVisit')
  //     observer.next(this.socket.ioSocket.id);
  //     console.log('createVisit',createVisit);
  //  });
  }

}
